var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfSellCarIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21748",
    "data-name": "\\uADF8\\uB8F9 21748",
    transform: "translate(-623 -1725)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28141",
    "data-name": "\\uC0AC\\uAC01\\uD615 28141",
    width: 40,
    height: 40,
    transform: "translate(623 1725)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28137",
    "data-name": "\\uC0AC\\uAC01\\uD615 28137",
    width: 5.499,
    height: 16.496,
    rx: 1.3,
    transform: "translate(629.252 1744.083)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28138",
    "data-name": "\\uC0AC\\uAC01\\uD615 28138",
    width: 5.499,
    height: 25.661,
    rx: 1.3,
    transform: "translate(640.25 1734.919)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28139",
    "data-name": "\\uC0AC\\uAC01\\uD615 28139",
    width: 5.499,
    height: 31.16,
    rx: 1.3,
    transform: "translate(651.248 1729.42)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1225",
    "data-name": "\\uD0C0\\uC6D0 1225",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(629 1733.708)",
    fill: "#ff6a13"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSellCarIcon4);
export default __webpack_public_path__ + "static/media/SelfSellCarIcon4.f571b6559fc07b71a68309c16083a317.svg";
export { ForwardRef as ReactComponent };